export default {
  surveyItem: 'survey_item',
  previewImg: 'file',
};
